export default __webpack_public_path__ + "static/media/A8.f55e62c3.jpeg";